import { render, staticRenderFns } from "./funding_record.vue?vue&type=template&id=33f448e1&scoped=true"
import script from "./funding_record.vue?vue&type=script&lang=js"
export * from "./funding_record.vue?vue&type=script&lang=js"
import style0 from "./funding_record.vue?vue&type=style&index=0&id=33f448e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f448e1",
  null
  
)

export default component.exports